var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('router-link',{class:_vm.nameClass,attrs:{"to":_vm.link}},[_vm._t("default")],2):(!_vm.link)?_c('div',{class:_vm.nameClass,on:{"click":function($event){return _vm.acao()}}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }